export default "__VITE_ASSET__C4EqTe9X__"